import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ArticleModule } from '@modules/article/article.module';
import { CardModule } from '@modules/card/card.module';
import { SharedModule } from '@modules/shared/shared.module';

import { PressKitCardWrapperService } from './press-kit-card-wrapper.service';
import { PressKitComponent } from './press-kit.component';

@NgModule({
  imports: [CommonModule, SharedModule, ArticleModule, CardModule, PressKitComponent],
  providers: [PressKitCardWrapperService],
  exports: [PressKitComponent],
})
export class PressKitModule {}
